import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { CookiesPopup } from 'pages/settings/CookiesSettings/CookiesPopup/CookiesPopup';
import { CookiesTable } from 'pages/settings/CookiesSettings/CookiesTable/CookiesTable';
import { withPageLanguage } from 'utils/enhancers';
import { ComponentWithPageLanguageProps } from 'utils/enhancers/withPageLanguage';
import { CookiesPopUp, Props, CookiesTable as CookiesTableProps, CookiesDataProps } from 'types';
import { cookiesDataModel, planogramsModel } from 'models';

import { HeaderHelpText } from '../style';

const CookiesSettings = ({
  planogramId,
  planogramVersion,
  pageLanguageTabValue = 0,
  handleValidationCheck,
  setSuccessActionMessages,
  handleServerError,
}: Props & ComponentWithPageLanguageProps): JSX.Element => {
  const { t } = useTranslation();
  const [cookiesSettings, setCookiesSettings] = useState<CookiesDataProps[]>([]);

  const getCookiesPopUpSettings = () => planogramsModel.getCookiesPopupSettings(planogramId, planogramVersion.id);

  const saveCookiesPopUpSettings = (settings: CookiesPopUp) =>
    planogramsModel.saveCookiesPopupSettings(settings, planogramId, planogramVersion.id);

  const getCookiesTableSettings = () => planogramsModel.getCookiesTableData(planogramId, planogramVersion.id);

  const saveCookiesTableSettings = (settings: CookiesTableProps) =>
    planogramsModel.saveCookiesTableData(settings, planogramId, planogramVersion.id);

  const getCookies = () => {
    cookiesDataModel.getData().then(setCookiesSettings);
  };

  const renderCookiesPopUpTitle = () => (
    <>
      {t('pages.settings.cookiesSettings.cookiesPopup.sphereTitle')} &nbsp;
      <HeaderHelpText>{t('pages.planograms.ManagePlanogramSettings.CustomOverlaySettings.titleHint')}</HeaderHelpText>
    </>
  );

  useEffect(() => {
    getCookies();
  }, []);

  return (
    <>
      <CookiesPopup
        getCookiesPopUpSettings={getCookiesPopUpSettings}
        saveCookiesPopUpSettings={saveCookiesPopUpSettings}
        expanded={false}
        customTitle={renderCookiesPopUpTitle()}
        planogramId={planogramId}
        planogramVersion={planogramVersion}
        pageLanguageTabValue={pageLanguageTabValue}
        handleValidationCheck={handleValidationCheck}
        handleServerError={handleServerError}
        setSuccessActionMessages={setSuccessActionMessages}
      />
      <CookiesTable
        expanded={false}
        cookiesDataSettings={cookiesSettings}
        getCookiesTableSettings={getCookiesTableSettings}
        saveCookiesTableSettings={saveCookiesTableSettings}
        pageLanguageTabValue={pageLanguageTabValue}
        setSuccessActionMessages={setSuccessActionMessages}
      />
    </>
  );
};

export default withPageLanguage(CookiesSettings);
